import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../../styles/Benefits.css';

const Barista = () => {
  const benefits = [
    {
      id: '01',
      title: 'Fast',
      description: 'Get essentials in minutes, not hours or days. No more waiting around for your package to arrive.',
      image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/owner3.png'
    },
    {
      id: '02',
      title: 'Convenient',
      description: 'Enjoy easy ordering in your favorite apps, real-time tracking down to the second, and precision drone delivery right to your home.',
      image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/roastertaste.png'
    },
    {
      id: '03',
      title: 'Eco friendly',
      description: 'With delivery at an all-time high, Wing drones take cars off the road, easing congestion and reducing environmental impact.',
      image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/b_1.png'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % benefits.length);
    }, 4000); // Change slide every 4 seconds
    return () => clearInterval(interval);
  }, [benefits.length]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.5 }
    },
    exit: { opacity: 0, y: -30 }
  };

  const imageVariants = {
    enter: { opacity: 0, y: 50 },
    center: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -50 }
  };

  return (
    <section className="benefits-section" id="benefits">
      <div className="container">
      <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <a href="#benefits" className="section-link">Barista</a>
          <h2 className="news-title">Baristas Rock</h2>
        </motion.div>

        <div className="benefits-container">
          <motion.div 
            className="benefits-list"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={benefits[currentIndex].id}
                className="benefit-item"
                variants={itemVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                transition={{ duration: 0.5 }}
              >
                <div className="benefit-number">{benefits[currentIndex].id}</div>
                <h3 className="benefit-title">{benefits[currentIndex].title}</h3>
                <p className="benefit-description">{benefits[currentIndex].description}</p>
              </motion.div>
            </AnimatePresence>
          </motion.div>

          <div className="benefits-image">
            <AnimatePresence mode="wait">
              <motion.img
                key={benefits[currentIndex].id}
                src={benefits[currentIndex].image}
                alt={benefits[currentIndex].title}
                className="benefits-image-item"
                style={{ width: '100%', height: 'auto', borderRadius: '10px' }}
                variants={imageVariants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{ duration: 0.5 }}
              />
            </AnimatePresence>
          </div>
        </div>

        <div className="carousel-indicators">
          {benefits.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Barista;